export const consultationServices = [
  'Web Development',
  'App Development',
  'UI/UX Designing',
  'Logo Making',
  'Video Editing',
  'Poster Making',
  'Full Brand Package',
  'Other'
];

export const consultationProjectTypes = [
  'New Build',
  'Redesign',
  'Ongoing Retainer',
  'MVP / Startup Launch',
  'Consulting Only',
  'Other'
];

export const consultationBudgets = [
  'Under $500',
  '$500 – $1,500',
  '$1,500 – $5,000',
  '$5,000 – $10,000',
  '$10,000+',
  'Not sure yet'
];

export const consultationTimelines = [
  'ASAP',
  '1 – 2 weeks',
  '2 – 4 weeks',
  '1 – 2 months',
  'Flexible'
];

export const consultationChannels = [
  'Email',
  'Phone',
  'WhatsApp',
  'Google Meet',
  'Zoom'
];

export const consultationDurations = [
  '15 minutes',
  '30 minutes',
  '45 minutes',
  '60 minutes'
];

export const consultationPurposes = [
  'Project Discovery',
  'Quote Discussion',
  'Strategy Session',
  'Technical Review',
  'Partnership Talk'
];

export const consultationTimezones = [
  'Asia/Kolkata (IST)',
  'UTC',
  'America/New_York (EST)',
  'America/Los_Angeles (PST)',
  'Europe/London (GMT)',
  'Europe/Berlin (CET)',
  'Asia/Dubai (GST)',
  'Asia/Singapore (SGT)',
  'Australia/Sydney (AEST)'
];

export const consultationSteps = [
  { id: 1, label: 'Project', title: 'Project Details' },
  { id: 2, label: 'Contact', title: 'Contact Information' },
  { id: 3, label: 'Schedule', title: 'Meeting Schedule' },
  { id: 4, label: 'Review', title: 'Review & Submit' },
  { id: 5, label: 'Done', title: 'Success' }
];

export const consultationDefaults = {
  service: '',
  projectType: '',
  budget: '',
  timeline: '',
  description: '',
  referenceUrl: '',
  name: '',
  company: '',
  email: '',
  phone: '',
  country: '',
  preferredCommunication: '',
  website: '',
  timezone: 'Asia/Kolkata (IST)',
  preferredDate: '',
  preferredTime: '',
  meetingDuration: '30 minutes',
  meetingPurpose: 'Project Discovery'
};
